import type { ArticleCard } from 'types/capi/shared';

import ArticleHighlightCarousel from './ArticleHighlightCarousel';
import Duo from './Duo';
import Feature from './Feature';
import Headlines from './Headlines';
import Highlights from './Highlights';
import { HomepageTiles } from './Tiles';

export type ArticlesSectionLayout =
  | 'duo'
  | 'carousel'
  | 'feature'
  | 'headlines'
  | 'highlights'
  | 'tiles';

export const MODULE_TYPES: Record<ArticlesSectionLayout, string> = {
  carousel: 'homepage-articles-carousel',
  duo: 'homepage-latest-articles-duo',
  feature: 'homepage-latest-feature',
  headlines: 'homepage-latest-articles-headlines',
  highlights: 'homepage-latest-articles-highlight',
  tiles: 'homepage-latest-articles-grid'
};

type Props = { modulePosition: number } & (
  | {
      items: ArticleCard[];
      layout: 'headlines' | 'highlights' | 'duo' | 'tiles' | 'carousel';
    }
  | { article: ArticleCard; layout: 'feature' }
);

export default function ArticlesSection(props: Props) {
  const modulePosition = props.modulePosition;

  switch (props.layout) {
    case 'duo':
      return <Duo items={props.items} modulePosition={modulePosition} />;
    case 'carousel':
      return (
        <ArticleHighlightCarousel
          items={props.items}
          modulePosition={modulePosition}
        />
      );
    case 'feature':
      return (
        <Feature
          article={props.article}
          modulePosition={modulePosition}
          moduleType={MODULE_TYPES.feature}
          pagePosition="Homepage Latest Feature"
        />
      );
    case 'headlines':
      return <Headlines items={props.items} modulePosition={modulePosition} />;
    case 'highlights':
      return <Highlights items={props.items} modulePosition={modulePosition} />;
    case 'tiles':
      return (
        <HomepageTiles
          items={props.items}
          modulePosition={modulePosition}
          moduleType={MODULE_TYPES.tiles}
          pagePosition="Homepage Article Tiles"
        />
      );
    default:
      return null;
  }
}
